import {AxiosInstance} from "axios";
import JournalEntry from "../model/journal/JournalEntry";

/**
 * Journal Api.
 */
export default class JournalApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch journal entries for partner brand.
	 * @returns {Promise<JournalEntry[]>} Promise containing all journal entries for partner brand.
	 */
	fetchJournalEntries(partnerBrandId: string): Promise<JournalEntry[]> {
		const url = `/api/web/accounting/partner_brands/${partnerBrandId}/journals`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(JournalEntry.fromJson));
	}
}
